import { Pair, mk_pair } from "widgets-for-react";
import { ImageSize } from "../../cms/blocks/types.gen";

export type ExtraImages = 
|'580w' 
| '210w' 
| 'super_grid' 
| 'tab' 
| 'media_block_large' 
| 'media_block_small' 
| 'featured_content' 
| '650x430'
| '1300x860'
| '1625x1075'

export let get_default_data_src : () => ImageSize<ExtraImages> = () => "full"
export let get_default_data_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () =>
  [
    //example: mk_pair('media_w432' as ExtraImages, "424w"),
  ]


export let case_slider_src : () => ImageSize<ExtraImages> = () => '650x430'
export let case_slider_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () =>
  [
    mk_pair('650x430' as ExtraImages, "650w"),
    mk_pair('1300x860' as ExtraImages, "1300w"),
    mk_pair('1625x1075' as ExtraImages, "1625w")
  ]
